<app-base-modal
  [title]="noteChangePriceModalResourceType.name"
  [modalMaxHeight]="'90vh'"
  [showStateToggle]="isValid()"
>
  <div class="wrapper">
    @if (isValid()) {
      <app-note-change-price-header
        [noteChangePriceData]="noteChangePriceData()"
      />
    }
    <app-note-change-price-form
      [noteChangePriceId]="noteChangePriceData().id"
      [noteChangePriceFormGroup]="noteChangePriceFormGroup"
      [isValid]="isValid()"
      [isEditModeActive]="isEditModeActive"
      (updateField)="handleUpdateField($event)"
    />
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
    @if (!isValid()) {
      <button
        mat-button
        color="primary"
        (click)="handleCreate()"
      >
        Сохранить
      </button>
    }
  </div>
</app-base-modal>
